module.exports = __webpack_public_path__ + "img/STERiJECT_01.3ddb8f04.png";